module.exports = __webpack_public_path__ + "static/img/favicon.9011906.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/favicon.png
// module id = 7Dx5
// module chunks = 1